import { MostViewedPropType } from "../types";

import Bag from "../../../assets/icons/bag.svg";

type PropType = {
  data: MostViewedPropType;
  onClick: (item: MostViewedPropType) => void;
};

const MostReviewedCard = ({ data, onClick }: PropType) => {
  return (
    <div>
      {data && (
        <div className="relative rounded-lg  bg-white flex flex-col gap-2 cursor-pointer">
          {data.establishment?.is_open === false && (
            <div className="absolute rounded-lg flex items-center justify-center top-0 bottom-0 left-0 right-0 bg-trans">
              <div className="font-medium text-base text-white">
                Temporarily Closed
              </div>
            </div>
          )}
          {data.discount.toString() !== "0.00" && (
            <div className="absolute left-4 top-3 bg-primary text-white font-normal text-xs rounded-sm p-2 px-3">
              {data.discount_type === "percent"
                ? `${data.discount}%`
                : ` ${data.establishment!.country.country_currency_symbol} ${
                    data.discount
                  }`}{" "}
              OFF
            </div>
          )}
          <div
            className="rounded-xl h-[150px] bg-cover bg-no-repeat bg-grey"
            onClick={() => onClick(data)}
            style={{ backgroundImage: `url(${data.image})` }}
          ></div>
          <div className="flex flex-col gap-1 whitespace-nowrap p-2">
            <div className="text-sm font-medium" onClick={() => onClick(data)}>
              {data.name}
            </div>
            <div
              className="text-xs text-[#727272] font-normal mb-3"
              onClick={() => onClick(data)}
            >
              {data.category?.name}
            </div>
            <div className="flex justify-between items-center mt-1">
              <div
                className="flex gap-2 items-baseline w-full"
                onClick={() => onClick(data)}
              >
                {data.discount.toString() !== "0.00" && (
                  <div className="text-[#727272] text-xs font-normal line-through">
                    {data.establishment!.country.country_currency_symbol}{" "}
                    {data.discount_type === "percent"
                      ? `${
                          Number(data.price) +
                          (Number(data.discount) / 100) * Number(data.price)
                        }`
                      : `${Number(data.price) + Number(data.discount)}`}
                  </div>
                )}
                <div className="text-primary font-semibold text-sm">
                  {data.establishment!.country.country_currency_symbol}{" "}
                  {data.price}
                </div>
              </div>
              <img
                src={Bag}
                alt=""
                className="cursor-pointer"
                onClick={() => {}}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MostReviewedCard;
